import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  const alphForm = jQuery('form#alph');
  const formSearch = '.form-search';
  const count = '[name=count]';
  const inputQ = 'input[name=q]';

  $(document).on('change', 'select' + count, (e: JQuery.ChangeEvent) => {
    console.log($(e.currentTarget).val())
    alphForm.find('input' + count).val($(e.currentTarget).val());
    alphForm.submit();
  });

  $(formSearch).on('change', inputQ, (e: JQuery.ChangeEvent) => {
    alphForm.find(inputQ).val($(e.currentTarget).val());
    alphForm.submit();
  });

  $(document).on('submit', formSearch, e => {
    e.preventDefault();
    alphForm.find(inputQ).val($(formSearch).find(inputQ).val());
    alphForm.submit();
  });

  $(document).on('submit', alphForm, e => {
    const url = new URL(<any>window.location);
    let page = url.searchParams.get('page');
    if (page) {
      url.searchParams.delete('page');
      // @ts-ignore
      history.pushState(null, null, url);
      window.location.reload();
    }
  });

});
